module.exports = __webpack_public_path__ + "img/R3_4_research_matsumoto2.e7657f28.png";